import { render, staticRenderFns } from "./_stand_by.vue?vue&type=template&id=18016320&"
import script from "./_stand_by.vue?vue&type=script&lang=js&"
export * from "./_stand_by.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports